jQuery(document).ready(function () {
  jQuery(".mod-logo-wall").each(function (index) {
    let slider = jQuery(this).find(".logo_list_slider");
    jQuery(slider).slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 2000,
      variableWidth: true,
      cssEase: "linear"
    });
  });
});
